import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { AddRemoveBlock } from '~/components/AddRemoveBlock/AddRemoveBlock';
import { FormPhoneField } from '~/components/FormComponents/FormPhoneField';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { commonStyles } from '~/theme/styles/commonStyles';

interface IPhoneListProps {
  disabled?: boolean;
  section?: string;
  hideActions?: boolean;
}

export const PhoneList = ({ disabled, section, hideActions }: IPhoneListProps) => {
  const { control } = useFormContext();
  const path = section ? section + '.' : '';
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${path}contactNumbers`,
  });

  useEffect(() => {
    if (fields.length === 0) {
      append('');
    }
  }, [fields, append]);

  return (
    <>
      {fields.map((item, index) => (
        <FormGridItem key={item.id} sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
          <FormPhoneField
            name={`${path}contactNumbers.${index}`}
            label="Номери контактних телефонів і факсів"
            disabled={disabled && index === 0}
          />
          {!hideActions && (
            <AddRemoveBlock
              add={() => append('')}
              remove={() => remove(index)}
              isPlusShown={fields.length < 3}
              isMinusShown={fields.length > 1}
              sx={{ mt: '12px' }}
              blockName={`${path}contactNumbers.${index}`}
            />
          )}
        </FormGridItem>
      ))}
    </>
  );
};
